export const toSwedishDate = (dateString) => {
  const monthNames = [
    'jan',
    'feb',
    'mar',
    'apr',
    'maj',
    'jun',
    'jul',
    'aug',
    'sep',
    'okt',
    'nov',
    'dec',
  ]

  const date = new Date(dateString)
  const day = date.getDate()
  const month = monthNames[date.getMonth()]

  return `${day} ${month}`
}
